<template>
  <el-dialog
    title="點數交易結果"
    :visible.sync="isVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="content">
      <div class="title">
        交易狀態
      </div>
      <div class="deal-status">
        <div class="el-icon el-icon-success" />
        <span>點數交易成功</span>
      </div>
      <br>
      <div class="title">
        出單機狀態
      </div>
      <div v-if="isPrintSkipped" class="printer-status">
        <div class="el-icon el-icon-info" />
        <span class="status">{{ $t('OrderFood.PrintSkippedBySetting') }}</span>
      </div>
      <div v-else-if="printersWithStatusAndResult.length===0" class="printer-no-ip">
        <div class="el-icon el-icon-error"></div>
        <div>
          列印失敗，出單機目前尚未設置IP位址。請先聯絡
          <span>智生活客服專線412-8166 (手機請加區碼)</span>
          完成設定再至點餐紀錄列表進行補單。
        </div>
      </div>
      <div v-else>
        <div
          v-for="item in printersWithStatusAndResult"
          :key="item.Ip"
          class="printer-status"
        >
          <div
            class="el-icon"
            :class="[item.IsFulfilled ? 'el-icon-success' : 'el-icon-error']"
          />
          <span class="deviceName">{{ item.Remark }}：</span>
          <span class="status">{{ item.Result }}</span>
        </div>
      </div>
    </div>
    <el-button
      type="primary"
      @click="isVisible = false"
    >
      確認
    </el-button>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      isVisible: false,
      isPrintSkipped: false, // 出單設定關閉、未出單
      printersWithStatusAndResult: []
    }
  },
  methods: {
    handleClose () {
      this.isVisible = false
      location.reload()
    },
    /**
     * 顯示交易結果
     * @param {Array|null} val 出單機結果陣列；null 表示出單設定關閉、未出單
     */
    setVal (val) {
      this.isPrintSkipped = val === null
      this.printersWithStatusAndResult = val || []
      this.isVisible = true
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .title {
    font-size: map-get($fontSize, 'large');
    font-size: bold;
  }
  .el-icon{
    padding-right: 5px;
    &.el-icon-success {
      color: $mainColor;
    }
    &.el-icon-error {
      color: $dangerColor;
    }
  }
  .content {
    text-align: start;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 35px;
  }
  .printer-no-ip{
    display: flex;
    color:$mainFontColor;
    line-height: 1.5rem;
    .el-icon{
        display: flex;
        align-items: center;
        height: 1.5rem;
      }
    span{
      color: $mainColor;
    }
  }
}
</style>
